import { cn as e } from "../cn.js";
import { MODAL_LAYER as t } from "../layers.js";
import { cva as n } from "class-variance-authority";
// src/design/drawer/style.ts
var r = n(["fixed inset-0 flex", t], {
	variants: { placement: {
		start: "justify-start items-stretch",
		end: "justify-end items-stretch",
		top: "justify-center items-start",
		bottom: "justify-center items-end",
		full: "justify-center items-center"
	} },
	defaultVariants: { placement: "end" }
}), i = n("relative bg-card shadow-overlay outline-hidden flex flex-col text-sm max-h-screen text-foreground transition-all duration-slow ease-enter", {
	variants: {
		placement: {
			start: "h-full data-[state=open]:animate-[slide-from-left-full_0.35s_cubic-bezier(0.16,1,0.3,1),fade-in_0.3s_ease-out] data-[state=closed]:animate-[slide-to-left-full_0.3s_cubic-bezier(0.7,0,0.84,0),fade-out_0.25s_ease-in]",
			end: "h-full data-[state=open]:animate-[slide-from-right-full_0.35s_cubic-bezier(0.16,1,0.3,1),fade-in_0.3s_ease-out] data-[state=closed]:animate-[slide-to-right-full_0.3s_cubic-bezier(0.7,0,0.84,0),fade-out_0.25s_ease-in]",
			top: "w-full data-[state=open]:animate-[slide-from-top-full_0.35s_cubic-bezier(0.16,1,0.3,1),fade-in_0.3s_ease-out] data-[state=closed]:animate-[slide-to-top-full_0.3s_cubic-bezier(0.7,0,0.84,0),fade-out_0.25s_ease-in]",
			bottom: "w-full data-[state=open]:animate-[slide-from-bottom-full_0.35s_cubic-bezier(0.16,1,0.3,1),fade-in_0.3s_ease-out] data-[state=closed]:animate-[slide-to-bottom-full_0.3s_cubic-bezier(0.7,0,0.84,0),fade-out_0.25s_ease-in]",
			full: "w-screen h-screen data-[state=open]:animate-[fade-in_0.35s_ease-out] data-[state=closed]:animate-[fade-out_0.3s_ease-in]"
		},
		size: {
			default: "",
			lg: "",
			xl: "",
			"2xl": "",
			"3xl": "",
			"4xl": "",
			"5xl": "",
			"6xl": "",
			25: "",
			half: "",
			50: "",
			60: "",
			75: "",
			full: "w-screen h-screen"
		}
	},
	compoundVariants: [
		{
			placement: ["start", "end"],
			size: "default",
			class: "w-96"
		},
		{
			placement: ["start", "end"],
			size: "lg",
			class: "w-[28rem]"
		},
		{
			placement: ["start", "end"],
			size: "xl",
			class: "w-[36rem]"
		},
		{
			placement: ["start", "end"],
			size: "2xl",
			class: "w-[42rem]"
		},
		{
			placement: ["start", "end"],
			size: "3xl",
			class: "w-[48rem]"
		},
		{
			placement: ["start", "end"],
			size: "4xl",
			class: "w-[56rem]"
		},
		{
			placement: ["start", "end"],
			size: "5xl",
			class: "w-[64rem]"
		},
		{
			placement: ["start", "end"],
			size: "6xl",
			class: "w-[72rem]"
		},
		{
			placement: ["start", "end"],
			size: "25",
			class: "w-[25vw]"
		},
		{
			placement: ["start", "end"],
			size: ["half", "50"],
			class: "w-[50vw]"
		},
		{
			placement: ["start", "end"],
			size: "60",
			class: "w-[60vw]"
		},
		{
			placement: ["start", "end"],
			size: "75",
			class: "w-[75vw]"
		},
		{
			placement: ["top", "bottom"],
			size: "default",
			class: "h-[80vh]"
		},
		{
			placement: ["top", "bottom"],
			size: "lg",
			class: "h-[90vh]"
		},
		{
			placement: ["top", "bottom"],
			size: "25",
			class: "h-[25vh]"
		},
		{
			placement: ["top", "bottom"],
			size: ["half", "50"],
			class: "h-[50vh]"
		},
		{
			placement: ["top", "bottom"],
			size: "60",
			class: "h-[60vh]"
		},
		{
			placement: ["top", "bottom"],
			size: "75",
			class: "h-[75vh]"
		}
	],
	defaultVariants: {
		placement: "end",
		size: "default"
	}
}), a = n([t, "fixed inset-0 bg-scrim backdrop-blur-xs/10 data-[state=open]:animate-[backdrop-fade-in_0.3s_cubic-bezier(0.16,1,0.3,1)_forwards] data-[state=closed]:animate-[backdrop-fade-out_0.25s_ease-in_forwards]"]), o = n("transition-all duration-normal ease-enter"), s = n("flex items-center gap-2 px-6 pt-4 pb-4"), c = n("flex-1 overflow-auto px-6 py-4"), l = n("flex items-center justify-end gap-3 px-6 pt-4 pb-4"), u = n("flex-1 text-md font-semibold"), d = n("text-muted-foreground"), f = n("absolute top-3 right-3 text-muted-foreground cursor-pointer hover:bg-muted p-1.5 rounded-md hover:text-foreground transition-colors duration-normal ease-enter"), p = n("flex justify-center py-2 touch-none cursor-grab active:cursor-grabbing"), m = n("h-1.5 w-10 rounded-full bg-border"), h = (t = "end", n = "default") => ({
	trigger: (t) => e(o(), t),
	positioner: (n) => e(r({ placement: t }), n),
	content: (r) => e(i({
		placement: t,
		size: n
	}), r),
	backdrop: (t) => e(a(), t),
	header: (t) => e(s(), t),
	body: (t) => e(c(), t),
	footer: (t) => e(l(), t),
	title: (t) => e(u(), t),
	description: (t) => e(d(), t),
	closeTrigger: (t) => e(f(), t),
	grabber: (t) => e(p(), t),
	grabberIndicator: (t) => e(m(), t)
});
export { h as getStyles };

//# sourceMappingURL=style.js.map